import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { buildHead } from "@/components/SEO";

export const Route = createFileRoute("/updates")({
  head: () =>
    buildHead({
      path: "/updates",
      title: "GoHub updates",
      description:
        "A monthly note for online eyewear retailers. One useful idea on selling prescription eyewear online, plus what we are shipping at GoHub.",
    }),
  component: lazyRouteComponent(() => import("@/pages/Updates")),
});
